import React from 'react'

import aSync from 'async'
import _ from 'underscore'

import AddressActions from '../../../actions/AddressActions.js'

import {Button, Card, IconButton, Popup} from '../../../components/UI/index.js'
import AddressModal from '../../../components/addresses/AddressModal.js'
import ImportModal from '../../../components/modals/importCSV/ImportModal.js'
import Table from '../../../components/UI/table/index.js'
import SearchBar from '../../../components/SearchBar/index.js'
import filter from '../../../utils/filter.js'
import csvExport from '../../../utils/csvExport.js'
import t from 'src/helpers/Languages.js'
import {formSpacing} from '../../../components/UI/forms/index.js'
import createMemo from '../../../utils/createMemo.js'
import {navOffset} from '../../../components/navigation/navPosition.js'

class AddressBookSettings extends React.Component {
    constructor(props) {
        super(props)

        this.columnsMemo = createMemo()

        this.state = {
            selectedAddresses: [],
            queries: []
        }
    }

    // The same columns until a value they read changes: new columns re-render every row of the table
    columns() {
        return this.columnsMemo([], () => this.buildColumns())
    }

    buildColumns() {
        return [
            {id: 'name', title: 'Naam', visible: true, key: 'name', width: 150},
            {id: 'attention', title: 'TAV', visible: true, key: 'attention', width: 100},
            {id: 'isBusiness', title: 'Bedrijfadres', visible: true, key: 'isBusiness', width: 80, text: (address) => {
                return address.isBusiness ? 'Ja' : 'Nee'
            }},
            {id: 'address', title: 'Adres', visible: true, key: 'address', flex: 2, text: ({street, nr, addition}) => `${street} ${nr}${addition}`},
            {id: 'postalCode', title: 'Postcode', visible: true, key: 'postalCode', width: 100},
            {id: 'city', title: 'Plaats', visible: true, key: 'city', flex: 1},
            {id: 'country', title: 'Land', visible: true, key: 'country', width: 75},
            {id: 'email', title: 'Email', visible: true, key: 'email', flex: 1},
            {id: 'phone', title: 'Telefoon', visible: true, key: 'phone', width: 150},
            {id: 'instructions', title: 'Instructies', visible: true, key: 'instructions', flex: 1},
            {id: 'edit', visible: true, showOnHover: true, width: 50, render: (address) => {
                return (
                    <IconButton onClick={this.onClickEdit.bind(this, address)}>
                        <i className='mdi mdi-pencil' />
                    </IconButton>
                )
            }}
        ]
    }

    onSaveAddress(address) {
        AddressActions.update([address], (err) => {
            if (err) {
                this.addressModal.setError(err)
            } else {
                this.addressModal.close()
            }
        })
    }

    onClickNew() {
        this.addressModal.open(undefined, this.onSaveAddress.bind(this))
    }

    onClickImport() {
        this.importModal.open()
    }

    onChangeImport(importedAddresses) {
        aSync.eachSeries(importedAddresses, (address, next) => {
            address = {
                name: address.name || '',
                attention: address.attention || '',
                street: address.street || '',
                nr: address.nr || '',
                addition: address.addition || '',
                street2: address.street2 || '',
                postalCode: address.postalCode || '',
                city: address.city || '',
                country: address.country || 'NL',
                email: address.email || '',
                phone: address.phone || '',
                instructions: address.instructions || ''
            }

            if (!address.name) {
                this.importModal.setError('Naam is verplicht in adres')
                return
            }

            AddressActions.update([address], (err) => {
                if (err) {
                    this.importModal.setError(err)
                } else {
                    next()
                }
            })
        }).then(() => {
            this.importModal.close()
        })
    }

    async onClickExport() {
        const {selectedAddresses} = this.state
        const {addressBook} = this.props
        const exportAddresses = []

        selectedAddresses.map((id) => {
            const address = _.findWhere(addressBook, {_id: id})

            if (address) {
                exportAddresses.push(address)
            }
        })

        await this.popup.openProgress(t('export'), '', (onProgress) => csvExport.addresses(exportAddresses, onProgress))

        this.setState({selectedAddresses: []})
    }

    onClickEdit(address) {
        this.addressModal.open(address, this.onSaveAddress.bind(this))
    }

    onClickRemove() {
        const {selectedAddresses} = this.state

        this.popup.open('Adressen verwijderen', 'Adressen worden definitief verwijderd.', () => {
            AddressActions.remove(selectedAddresses)
            this.popup.close()
            this.setState({selectedAddresses: []})
        })
    }

    onChangeQueries(queries) {
        this.table.selectPage(1)
        this.setState({queries})
    }

    onTableChange(selectedAddresses) {
        this.setState({selectedAddresses})
    }

    render() {
        const {queries, selectedAddresses} = this.state
        const {reseller, addressBook, user} = this.props

        const addresses = filter.addresses(addressBook, queries, reseller)

        return (
            <div style={{display: 'flex', flexDirection: 'column', height: `calc(100vh - ${60 + navOffset().top}px)`}}>
                <Card shadow style={{display: 'flex', columnGap: formSpacing.columnGap, padding: 24, width: '100%'}}>

                    <SearchBar
                        columns={this.columns()}
                        onQueryChange={this.onChangeQueries.bind(this)}
                        queries={queries}
                    />

                    <Button onClick={this.onClickNew.bind(this)}>
                        Nieuw adres
                    </Button>

                    <Button onClick={this.onClickImport.bind(this)}>
                        <i className='mdi mdi-file-import' />
                    </Button>

                    {selectedAddresses.length > 0 &&
                        <>
                            <Button onClick={this.onClickExport.bind(this)}>
                                <i className='mdi mdi-file-export' />
                            </Button>

                            <Button onClick={this.onClickRemove.bind(this)}>
                                <i className='mdi mdi-delete' />
                            </Button>
                        </>
                    }
                </Card>

                <div style={{flex: 1, marginTop: 24}}>
                    <Table
                        tableName='customerAddressBook'
                        legacyTableName='addressBook'
                        columns={this.columns()}
                        rows={addresses}
                        selectedRows={selectedAddresses}
                        onChange={this.onTableChange.bind(this)}
                        ref={(ref) => this.table = ref}
                    />
                </div>

                <AddressModal
                    showPx={!!user.settings.pxEnabled}
                    showInstructions
                    ref={(ref) => this.addressModal = ref}
                />

                <ImportModal
                    ref={(ref) => this.importModal = ref}
                    possibleColumns={possibleColumns}
                    isAddressBook
                    onChange={this.onChangeImport.bind(this)}
                />

                <Popup ref={(ref) => this.popup = ref} />
            </div>
        )
    }
}

const possibleColumns = {
    name: 'Naam',
    attention: 'T.a.v.',
    street: 'Straat',
    nr: 'Nr',
    addition: 'Toevoeging',
    streetNr: 'Straat + nr + toevoeging',
    nrAddition: 'Nr + toevoeging',
    street2: '2e adres regel',
    postalCode: 'Postcode',
    city: 'Plaats',
    country: 'Land',
    email: 'Emailadres',
    phone: 'Telefoon',
    comment: 'Opmerking',
    instructions: 'Instructies'
}

export default AddressBookSettings
